<template>
  <div>
    <PromptControl
      @ok="promptOk"
      @cancel="promptCancel"
      @closed="promptClosed"
      v-bind:show="cancel_prompt.display"
      v-bind:title="lang('lbl_0000515')"
      v-bind:message="lang('lbl_0000514')"
    />

    <ContentWrapperControl>
      <div class="bg-white p-4 rounded-b-lg shadow mb-4">
        <div
          v-text="lang('lbl_0000160')"
          class="text-sm text-grey-darkest leading-normal"
        ></div>
      </div>

      <div class="bg-white p-4 rounded-lg shadow">
        <div class="mb-4">
          <TextboxControl
            @typing="typing"
            v-bind:value="new_password"
            v-bind:placeholder="lang('lbl_0000047')"
            type="password"
            name="new_password"
            required
            strength
          />

          <span
            v-if="error_message"
            class="text-xs font-semibold text-red"
          >
            {{ error_message }}
          </span>
        </div>

        <div class="mb-4">
          <TextboxControl
            @typing="typing"
            @strong="strong"
            v-bind:value="con_password"
            v-bind:placeholder="lang('lbl_0000048')"
            type="password"
            name="con_password"
            required
          />
        </div>
        
        <div class="mb-4">
            <span
              v-if="notMatching"
              class="text-xs font-semibold text-red"
            >
              {{ lang("lbl_0000237") }}
            </span>
        </div>
        <div>
          <ButtonControl v-on:click="update" v-bind:disabled="disabled">
            {{ lang("lbl_0000050") }}
          </ButtonControl>
        </div>
      </div>
    </ContentWrapperControl>
  </div>
</template>

<script>
import ButtonControl from "./../../components/controls/ButtonControl.vue";
import ContentWrapperControl from "./../../components/controls/ContentWrapperControl.vue";
import TextboxControl from "./../../components/controls/TextControl.vue";
import PromptControl from "./../../components/controls/PromptControl.vue";
import User from "./../../services/User.js";
import mixin from "./../../mixin.js";

export default {
  mixins: [mixin],

  components: {
    ButtonControl,
    ContentWrapperControl,
    TextboxControl,
    PromptControl,
  },

  data() {
    return {
      new_password: "",
      con_password: "",
      disabled: true,
      passed: false,
      error_message: "",

      allowNavigation: false,

      cancel_prompt: {
        display: false,
      },
    };
  },

  computed: {
    notMatching() {
      return (
        this.new_password.length > 0 &&
        this.con_password.length > 0 &&
        this.new_password !== this.con_password
      );
    },
  },

  beforeRouteLeave(to, from, next) {
    if (this.allowNavigation) {
      next();
      return;
    }

    this.cancel_prompt.display = true;

    next(false);
  },

  mounted() {
    this.$emit("checkauth", false);

    this.$emit("shownavbar", {
      title: this.lang("lbl_0000049"),
      show: true,
      back: true,
    });

    let state = this.$store.state.forgot;

    if (state.hash == null || state.pin == null) {
      this.allowNavigation = true;
      this.$router.push("/forgot-password");
      return;
    }
  },

  methods: {
    strong(passed) {
      this.passed = passed;
    },

    typing(obj) {
      this[obj.name] = obj.value;

      // Clear API error when the user starts typing again
      this.error_message = "";

      this.disabled =
        this.new_password.length === 0 ||
        this.con_password.length === 0 ||
        this.new_password !== this.con_password ||
        !this.passed;
    },

    update() {
      let state = this.$store.state.forgot;

      // Clear previous API error
      this.error_message = "";

      this.$emit("showloader");

      User.forgotPasswordUpdate(state.uuid, {
        hash: state.hash,
        pin: state.pin,
        otp_token: state.otp.token,
        otp_pin: state.otp.pin,
        password: this.new_password,
        con_password: this.con_password,
      })
        .then(() => {
          this.$emit("hideloader");
          this.allowNavigation = true;
          this.$router.push("/forgot-password/success");
        })
        .catch((error) => {
          this.$emit("hideloader");

          this.error_message = this.getErrorMessage(error);
        });
    },

    getErrorMessage(error) {
      if (!error) {
        return "An error occurred while updating your password.";
      }

      if (error.response && error.response.data) {
        const data = error.response.data;

        if (typeof data === "string") {
          return data;
        }

        if (data.message) {
          return data.message;
        }

        if (data.error) {
          return data.error;
        }

        if (data.errors) {
          if (typeof data.errors === "string") {
            return data.errors;
          }

          if (Array.isArray(data.errors)) {
            return data.errors.join(", ");
          }

          const messages = Object.values(data.errors).flat();

          if (messages.length > 0) {
            return messages.join(", ");
          }
        }
      }

      if (error.message) {
        return error.message;
      }

      if (typeof error === "string") {
        return error;
      }

      return "An error occurred while updating your password.";
    },

    promptOk() {
      let state = this.$store.state.forgot;

      state.value = null;
      state.uuid = null;
      state.hash = null;
      state.pin = null;
      state.email = null;
      state.mobile = null;
      state.otp.pin = null;
      state.otp.token = null;

      this.allowNavigation = true;
      this.cancel_prompt.display = false;
      this.$router.push("/");
    },

    promptCancel() {
      this.cancel_prompt.display = false;
    },

    promptClosed() {
      this.cancel_prompt.display = false;
    },
  },
};
</script>